import { Link } from 'react-router-dom';
import {
  ArrowRight,
  BadgeCheck,
  Mail,
  MapPin,
  Phone,
  ShieldCheck,
} from 'lucide-react';
import AppLogo from '../common/AppLogo';
import {
  APP_NAME,
  APP_SHORT_DESCRIPTION,
  PAYMENT_METHODS_LABEL,
  PAYMENT_PROVIDER,
  SUPPORT_CITY,
  SUPPORT_EMAIL,
  SUPPORT_PHONE,
} from '../../config/brand';

const quickLinks = [
  { to: '/explore', label: 'Explorer les campagnes' },
  { to: '/dashboard/create', label: 'Créer une campagne' },
  { to: '/garantie', label: 'Confiance et sécurité' },
];

const legalLinks = [
  { to: '/about', label: 'À propos' },
  { to: '/terms', label: 'Conditions d’utilisation' },
  { to: '/privacy', label: 'Politique de confidentialité' },
  { to: '/faq', label: 'FAQ' },
];

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="border-t app-border bg-primary-800 text-white">
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
        <div className="grid gap-12 lg:grid-cols-[1.2fr_0.9fr_0.9fr_1fr]">
          <div className="space-y-5">
            <AppLogo withWordmark iconClassName="border-white/10" wordmarkClassName="text-white" captionClassName="text-white/55" />
            <p className="max-w-sm text-sm leading-7 text-white/72">{APP_SHORT_DESCRIPTION}</p>
            <div className="space-y-3 rounded-[1.5rem] border border-white/10 bg-white/5 p-5">
              <div className="flex items-center gap-3 text-sm">
                <ShieldCheck className="h-4 w-4 text-accent-300" />
                <span>Paiement via {PAYMENT_PROVIDER}</span>
              </div>
              <div className="flex items-center gap-3 text-sm">
                <BadgeCheck className="h-4 w-4 text-accent-300" />
                <span>{PAYMENT_METHODS_LABEL}</span>
              </div>
            </div>
          </div>

          <div>
            <h3 className="font-display text-lg font-semibold">Navigation</h3>
            <ul className="mt-5 space-y-3">
              {quickLinks.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="group inline-flex items-center gap-2 text-sm text-white/72 transition-colors hover:text-white"
                  >
                    <ArrowRight className="h-4 w-4 opacity-0 transition-all group-hover:opacity-100" />
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-display text-lg font-semibold">Informations</h3>
            <ul className="mt-5 space-y-3">
              {legalLinks.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="group inline-flex items-center gap-2 text-sm text-white/72 transition-colors hover:text-white"
                  >
                    <ArrowRight className="h-4 w-4 opacity-0 transition-all group-hover:opacity-100" />
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-display text-lg font-semibold">Contact</h3>
            <div className="mt-5 space-y-4 text-sm text-white/72">
              <a href={`mailto:${SUPPORT_EMAIL}`} className="flex items-start gap-3 hover:text-white">
                <Mail className="mt-0.5 h-4 w-4 text-accent-300" />
                <span>{SUPPORT_EMAIL}</span>
              </a>
              {SUPPORT_PHONE ? (
                <a href={`tel:${SUPPORT_PHONE.replace(/\s+/g, '')}`} className="flex items-start gap-3 hover:text-white">
                  <Phone className="mt-0.5 h-4 w-4 text-accent-300" />
                  <span>{SUPPORT_PHONE}</span>
                </a>
              ) : null}
              <div className="flex items-start gap-3">
                <MapPin className="mt-0.5 h-4 w-4 text-accent-300" />
                <span>{SUPPORT_CITY}</span>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-white/10 pt-6 text-sm text-white/55 md:flex-row md:items-center md:justify-between">
          <p>© {currentYear} {APP_NAME}. Tous droits réservés.</p>
          <p>Produit conçu pour renforcer la confiance sur les campagnes locales et la diaspora.</p>
        </div>
      </div>
    </footer>
  );
}
